import { render, staticRenderFns } from "./UpsellPackageRow.vue?vue&type=template&id=498eb2cb"
import script from "./UpsellPackageRow.vue?vue&type=script&lang=js"
export * from "./UpsellPackageRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports